if (!customElements.get('layout-switcher')) {
  class LayoutSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addLayoutSwitcherListeners();
    }

    addLayoutSwitcherListeners() {
      const layoutSwitcherEl = this.querySelector('.js-layout-switcher');
      layoutSwitcherEl.addEventListener('click', this.onLayoutSwitch.bind(this));
    }

    onLayoutSwitch(event) {
      const layoutBtnEl = event.target.closest(".js-layout-btn");
      if (!layoutBtnEl) return;

      this.resetLayoutSwitchers();
      this.setActiveLayoutSwitcher(layoutBtnEl);
      this.setLayout(layoutBtnEl?.dataset.layout === 'mixed' ? true : false);
    }

    setLayout(isMixed) {
      const collectionWrapper = document.querySelector('.js-grid-layout');
      if (collectionWrapper) collectionWrapper.classList.toggle("grid--mixed", isMixed);
    }

    resetLayoutSwitchers() {
      this.querySelectorAll(".js-layout-btn").forEach(btn => {
        btn.classList.remove('active');
      });
    }

    setActiveLayoutSwitcher(layoutBtnEl) {
      layoutBtnEl.classList.add('active');
    }
  }

  customElements.define('layout-switcher', LayoutSwitcher);
}
